import React, { useState } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { motion } from 'framer-motion';
import { BRAND, services, timeSlots } from '../data/content';
import { BookingCalendar } from './BookingCalendar';
import { SectionHeading } from './SectionHeading';
import { ArrowRightIcon, CalendarIcon, CheckIcon, ClockIcon, WhatsappIcon } from './icons/LineIcons';
const fieldClass = 'w-full rounded-md border border-steel/70 bg-ink px-4 py-3 font-sans text-sm text-white placeholder:text-white/30 transition-colors duration-300 focus:border-gold focus:outline-none';
const labelClass = 'mb-2 block font-sans text-[11px] uppercase tracking-[0.2em] text-ash';
export function Booking() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [service, setService] = useState(services[0].id);
  const [date, setDate] = useState<Date | null>(null);
  const [slot, setSlot] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const selectedService = services.find(item => item.id === service);
  const whatsappRequestUrl = () => {
    const formattedDate = date ? format(date, "d 'de' MMMM yyyy", {
      locale: es
    }) : '';
    const message = ['Hola Norberth, quiero solicitar una reunión.', '', `Nombre: ${name.trim()}`, `Correo: ${email.trim()}`, company.trim() ? `Empresa o proyecto: ${company.trim()}` : null, `Servicio: ${selectedService?.title ?? ''}`, `Fecha: ${formattedDate}`, `Horario: ${slot ?? ''}`].filter(Boolean).join('\n');
    return `${BRAND.whatsappUrl}?text=${encodeURIComponent(message)}`;
  };
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!name.trim() || !email.trim()) {
      setError('Completa tu nombre y correo para continuar.');
      return;
    }
    if (!date || !slot) {
      setError('Selecciona una fecha y un horario disponibles.');
      return;
    }
    setError('');
    setSent(true);
    window.open(whatsappRequestUrl(), '_blank', 'noopener,noreferrer');
  };
  return <section id="reunion" className="relative w-full overflow-hidden bg-graphite py-20 sm:py-24 lg:py-32" aria-labelledby="reunion-title" data-id="element-47" data-mp="2uabyllnlo232">
      <div aria-hidden="true" className="pointer-events-none absolute right-0 top-1/4 hidden h-80 w-80 rounded-full bg-gold/[0.06] blur-3xl lg:block" data-id="element-48" data-mp="21kv5smw2ij6b" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10" data-id="element-49" data-mp="26lsqb64jvpaz">
        <SectionHeading eyebrow="Agenda" title={<span id="reunion-title" data-id="element-51" data-mp="2fkwa6cbjk8qj">
              Solicitar una <span className="text-gold" data-id="element-52" data-mp="2fi9zi3tctd43">reunión</span>
            </span>} description="Elige el servicio, la fecha y el horario. La reunión queda sujeta a confirmación de agenda." align="center" data-id="element-50" data-mp="2akiapio0a744" />

        <div className="relative mx-auto mt-12 max-w-5xl lg:mt-16" data-id="element-53" data-mp="4xsuxrnzr03w">
          <div aria-hidden="true" className="absolute -inset-3 rounded-[16px] bg-gold/[0.05] blur-3xl" data-id="element-54" data-mp="506uacppeyh9" />

          {sent ? <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="relative rounded-card border border-gold/40 bg-anthracite p-8 text-center sm:p-12" role="status" data-id="element-55" data-mp="3rcccfx89ivel">
              <span className="mx-auto grid h-14 w-14 place-items-center rounded-full border border-gold/50 text-gold" data-id="element-56" data-mp="3dcb09lmjs1jt">
                <CheckIcon className="h-6 w-6" data-id="element-57" data-mp="38gvor0c0ihqk" />
              </span>
              <h3 className="mt-6 font-display text-2xl uppercase tracking-wide text-white sm:text-3xl" data-id="element-58" data-mp="34eit54qzc07i">
                Solicitud enviada
              </h3>
              <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-ash" data-id="element-59" data-mp="12m44znxudzin">
                {selectedService?.title} —{' '}
                {date ? format(date, "d 'de' MMMM yyyy", {
              locale: es
            }) : ''}{' '}
                a las {slot}. Se abrió WhatsApp con los datos de tu solicitud;
                envía el mensaje para confirmar.
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-60" data-mp="14poak4d351iq">
                <a href={whatsappRequestUrl()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 rounded-md bg-gold px-7 py-4 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-all duration-300 hover:bg-goldsoft" data-id="element-61" data-mp="qyt93d4x1mp6">
                  <WhatsappIcon className="h-4 w-4" data-id="element-62" data-mp="lx3u5mekoovt" />
                  Confirmar por WhatsApp
                </a>
                <button type="button" onClick={() => setSent(false)} className="inline-flex items-center justify-center gap-2 rounded-md border border-steel/70 px-7 py-4 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-white transition-colors duration-300 hover:border-gold/60 hover:text-gold" data-id="element-63" data-mp="cyigo5nyk01w">
                  Editar solicitud
                </button>
              </div>
            </motion.div> : <motion.form initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.6
        }} onSubmit={onSubmit} noValidate className="relative grid gap-8 rounded-card border border-white/[0.08] bg-anthracite p-6 sm:p-9 lg:grid-cols-2 lg:gap-10" data-id="element-64" data-mp="cbksfwsu8p5t">
              <div className="space-y-6" data-id="element-65" data-mp="v3dlfr7wqadj">
                <div data-id="element-66" data-mp="v09b0c3umief">
                  <label className={labelClass} htmlFor="booking-name" data-id="element-67" data-mp="q38zvms56pgg">
                    Nombre completo
                  </label>
                  <input id="booking-name" className={fieldClass} value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" autoComplete="name" data-id="element-68" data-mp="3jwa4ekm76cl1" />
                </div>
                <div data-id="element-69" data-mp="1iiz9h63h2au">
                  <label className={labelClass} htmlFor="booking-email" data-id="element-70" data-mp="1j2jx5n4q4sk">
                    Correo electrónico
                  </label>
                  <input id="booking-email" type="email" className={fieldClass} value={email} onChange={e => setEmail(e.target.value)} placeholder="nombre@empresa.com" autoComplete="email" data-id="element-71" data-mp="bemdhle80re5" />
                </div>
                <div data-id="element-72" data-mp="2m7guziue0iu5">
                  <label className={labelClass} htmlFor="booking-company" data-id="element-73" data-mp="2m6ovvy1l02z4">
                    Empresa o proyecto
                  </label>
                  <input id="booking-company" className={fieldClass} value={company} onChange={e => setCompany(e.target.value)} placeholder="Opcional" autoComplete="organization" data-id="element-74" data-mp="2ep8v3pn90ykp" />
                </div>

                <fieldset data-id="element-75" data-mp="2xmjs13lerfwz">
                  <legend className={labelClass} data-id="element-76" data-mp="2xlqwkyrwgcu5">Servicio de interés</legend>
                  <div className="grid grid-cols-2 gap-2" data-id="element-77" data-mp="2sn78arpu2oym">
                    {services.map(item => {
                  const active = item.id === service;
                  return <button key={item.id} type="button" onClick={() => setService(item.id)} aria-pressed={active} className={`rounded-md border px-3 py-3 text-left font-sans text-xs leading-snug transition-all duration-300 ${active ? 'border-gold/70 bg-gold/10 text-white' : 'border-steel/60 text-ash hover:border-gold/40 hover:text-white'}`} data-id="element-78" data-mp="2jnk4y0djn92x">
                          {item.title}
                        </button>;
                })}
                  </div>
                </fieldset>
              </div>

              <div className="space-y-6" data-id="element-79" data-mp="3w07gj2rxl0ex">
                <div data-id="element-80" data-mp="3vywdx6a81ype">
                  <span className={`${labelClass} flex items-center gap-2`} data-id="element-81" data-mp="3w1ij4z9n424g">
                    <CalendarIcon className="h-4 w-4 text-gold" data-id="element-82" data-mp="3hajfm2nnw3rq" />
                    Selecciona una fecha
                  </span>
                  <BookingCalendar selected={date} onSelect={value => {
                setDate(value);
                setSlot(null);
              }} data-id="element-83" data-mp="du2yf81e1ru5" />
                </div>

                <div data-id="element-84" data-mp="239x1ag2comv6">
                  <span className={`${labelClass} flex items-center gap-2`} data-id="element-85" data-mp="2393ujf3e5xd1">
                    <ClockIcon className="h-4 w-4 text-gold" data-id="element-86" data-mp="1ybluyfb9kuhp" />
                    Horario disponible
                  </span>
                  <div className="grid grid-cols-3 gap-2" data-id="element-87" data-mp="2c5mnusfjbna5">
                    {timeSlots.map(time => {
                  const active = slot === time;
                  return <button key={time} type="button" disabled={!date} onClick={() => setSlot(time)} aria-pressed={active} className={`rounded-md border py-2.5 font-sans text-sm transition-all duration-300 ${active ? 'border-gold bg-gold font-semibold text-ink' : 'border-steel/60 text-white/85 hover:border-gold/50 hover:text-gold'} disabled:cursor-not-allowed disabled:border-steel/30 disabled:text-white/25 disabled:hover:text-white/25`} data-id="element-88" data-mp="1keggps1ecpbd">
                          {time}
                        </button>;
                })}
                  </div>
                </div>

                {error ? <p className="font-sans text-sm text-gold" role="alert" data-id="element-89" data-mp="io1lgo6p3k5y">
                    {error}
                  </p> : null}

                <button type="submit" className="group inline-flex w-full items-center justify-center gap-3 rounded-md bg-gold px-7 py-4 font-sans text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-all duration-300 hover:bg-goldsoft hover:shadow-[0_0_40px_-10px_rgba(245,197,24,0.95)] active:translate-y-px" data-id="element-90" data-mp="dndnfik1u328">
                  Enviar solicitud
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-91" data-mp="1z32va0atlq9c" />
                </button>
              </div>
            </motion.form>}
        </div>
      </div>
    </section>;
}